import { edmCampaign } from '@bingads-webui/edm-campaign';

const getEdmEntity = (api, cid, aid, campaignId) => {
  if (campaignId) {
    return edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Campaigns.$withKey(campaignId)[api];
  }
  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)[api];
};

export const loadBusinessInfoRecommendation = (payload, cid, aid, campaignId) => {
  const edmEntity = getEdmEntity('Default.GetExtractedBusinessInfo', cid, aid, campaignId);
  return edmEntity.$makeCall({
    payload,
  }).toPromise();
};

export const loadTargetRecommendation = (payload, cid, aid) => {
  const edmEntity = getEdmEntity('Default.GetTargetSuggestions', cid, aid, undefined);
  return edmEntity.$makeCall({
    payload,
  }).toPromise();
};
